// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import messages from './international/' //多语言文字
// import ElementUI from "element-ui"
// import "element-ui/lib/theme-default/index.css"
import VueResource from 'vue-resource'
import "font-awesome/css/font-awesome.css"
import {
  Pagination,
  Dialog,
  // Autocomplete,
  // Dropdown,
  // DropdownMenu,
  // DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  // MenuItemGroup,
  Input,
  // InputNumber,
  // Radio,
  // RadioGroup,
  // RadioButton,
  // Checkbox,
  // CheckboxGroup,
  // Switch,
  Select,
  Option,
  // OptionGroup,
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  DatePicker,
  // TimeSelect,
  // TimePicker,
  Popover,
  Tooltip,
  // Breadcrumb,
  // BreadcrumbItem,
  Form,
  FormItem,
  // Tabs,
  // TabPane,
  Tag,
  // Tree,
  // Alert,
  // Slider,
  Icon,
  Row,
  Col,
  Upload,
  // Progress,
  // Spinner,
  // Badge,
  // Card,
  // Rate,
  Steps,
  Step,
  // Carousel,
  // Scrollbar,
  // CarouselItem,
  // Collapse,
  // CollapseItem,
  // Cascader,
  // ColorPicker,
  Transfer,
  Loading,
  MessageBox,
  Message,
  Notification
} from 'element-ui'

Vue.use(Pagination)
Vue.use(Dialog)
// Vue.use(Autocomplete)
// Vue.use(Dropdown)
// Vue.use(DropdownMenu)
// Vue.use(DropdownItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
// Vue.use(MenuItemGroup)
Vue.use(Input)
// Vue.use(InputNumber)
// Vue.use(Radio)
// Vue.use(RadioGroup)
// Vue.use(RadioButton)
// Vue.use(Checkbox)
// Vue.use(CheckboxGroup)
// Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
// Vue.use(OptionGroup)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
// Vue.use(TimeSelect)
// Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Tooltip)
// Vue.use(Breadcrumb)
// Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
// Vue.use(Tabs)
// Vue.use(TabPane)
Vue.use(Tag)
// Vue.use(Tree)
// Vue.use(Alert)
// Vue.use(Slider)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Upload)
// Vue.use(Progress)
// Vue.use(Spinner)
// Vue.use(Badge)
// Vue.use(Card)
// Vue.use(Rate)
Vue.use(Steps)
Vue.use(Step)
// Vue.use(Carousel)
// Vue.use(Scrollbar)
// Vue.use(CarouselItem)
// Vue.use(Collapse)
// Vue.use(CollapseItem)
// Vue.use(Cascader)
// Vue.use(ColorPicker)
Vue.use(Transfer)
Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message



// Vue.use(ElementUI)
Vue.use(VueResource)
Vue.config.productionTip = false

Vue.http.interceptors.push((request, next) => {

  // modify request ...
  // console.log(this)
  if(sessionStorage.getItem("accessToken")){
    // next(request.respondWith(body, {
    //   status: 404,
    //   statusText: 'Not found'
    // }));
    next((response) => {
      // console.log(response)
      // if (res.status === 401) {
      //   return Promise.resolve(refreshToken().then(_ => Vue.http(req)))
      // }
      if(response.data.error_code === 21327){
        let token = window.sessionStorage.getItem('refreshToken')
        return Vue.http.post(
          '/oauth2/access_token', {}, {
            params:{
              client_id: '17953450251798098136',
              client_secret: '08E9EC6793345759456CB8BAE52615F3',
              grant_type: "refresh_token",
              refresh_token: token
            },
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        ).then((response) => {
          sessionStorage.setItem('accessToken', response.data.access_token)
          let refresh_token = response.data.refresh_token
          if(token !== refresh_token){
            sessionStorage.setItem('refreshToken', refresh_token)
          }
          request.params.access_token = response.data.access_token
          return Vue.http(request).then((data) => {
              return data
          })
        }).catch(() => {
          sessionStorage.clear()
          return router.go({name: 'login'})
        })
      }
    })
  }else{
    next()
  }
  // stop and return response

});


//国际化
Vue.use(VueI18n)
// let langNow;
// if (localStorage.lang) {
//   langNow = localStorage.lang;
// } else {
//   localStorage.lang = 'en';
//   langNow = 'en';
// }
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'zh', // set locale
  messages, // set locale messages
});
ElementLocale.i18n((key, value) => i18n.t(key, value))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js